module.exports = __webpack_public_path__ + "img/white-label-preview.2f531ba0.png";